/* unplugin-vue-components disabled */import { render } from "./Caps.vue?vue&type=template&id=6d0c6bb8"
import script from "./Caps.vue?vue&type=script&lang=js"
export * from "./Caps.vue?vue&type=script&lang=js"

import exportComponent from "E:\\电梯项目文档\\lcFrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__